import React from 'react'

export default function Hospitality() {
  return (
    <div>Hospitality</div>
  )
}
